import init from './flos-init';

init(typeof initOptions !== 'undefined' ? initOptions : null);

$(document).on('ngloaded', () => {
    init({
        disableFeedbackButton: true
    });
});
